<template>
  <div>
  </div>
</template>
<script>
export default {
  created () {
    const $this = this

    $this.$http
      .post(`${process.env.VUE_APP_API_ENDPOINT}/team/billing_redirect`, {return_url: window.location.origin + $this.$router.referer.path}, {
        headers: { 'Authorization': `Bearer ${localStorage.jwt}` }
      })
      .then(response => {
        window.location.replace(response.data.url)
      })
  }
}
</script>
